import formatDate from 'helpers/formatDate';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';

/**
 * This component shows meta data of a release.
 */
function ReleaseMetadata({
  entityId,
  releaseDate,
  primaryArtist,
  showDetailedMetadata,
  displayName,
  topic,
}) {
  return (
    <Meta>
      {topic && topic.includes('social')
        ? shouldRenderValue(displayName) && <span>{displayName}</span>
        : shouldRenderValue(primaryArtist) && (
            <span>{`${
              showDetailedMetadata ? 'Release ' : ''
            }by ${primaryArtist}`}</span>
          )}
      {shouldRenderValue(releaseDate) && (
        <span>{`${formatDate(releaseDate, 'day-short')}`}</span>
      )}
      {shouldRenderValue(entityId) && <span>{`UPC/EAN: ${entityId}`}</span>}
    </Meta>
  );
}

ReleaseMetadata.propTypes = {
  ...metadataProps,
};

export default ReleaseMetadata;
